import api from './api'
import { normalizeFotoUrl } from '../utils/avatarHelpers'

// Función helper para normalizar fotos en una mascota
function normalizeMascotaFoto(mascota) {
  if (!mascota) return mascota
  
  // Normalizar foto o avatar_url de la mascota
  if (mascota.foto) {
    mascota.foto = normalizeFotoUrl(mascota.foto)
  } else if (mascota.avatar_url) {
    mascota.foto = normalizeFotoUrl(mascota.avatar_url)
    mascota.avatar_url = mascota.foto // Mantener consistencia
  }
  
  // Si tiene dueño, normalizar su foto también
  if (mascota.dueño || mascota.dueno) {
    const dueno = mascota.dueño || mascota.dueno
    if (dueno.avatar) {
      dueno.avatar = normalizeFotoUrl(dueno.avatar)
    }
    if (dueno.foto) {
      dueno.foto = normalizeFotoUrl(dueno.foto)
    }
    if (dueno.avatar_url) {
      dueno.avatar_url = normalizeFotoUrl(dueno.avatar_url)
    }
  }
  
  return mascota
}

export const mascotaService = {
  async getAll(params = {}) {
    const response = await api.get('/mascotas', { params })
    
    // Normalizar fotos en todas las mascotas
    if (response.data?.success && response.data?.data) {
      const mascotas = Array.isArray(response.data.data) 
        ? response.data.data 
        : (response.data.data.data || [])
      
      mascotas.forEach(normalizeMascotaFoto)
    } else if (Array.isArray(response.data)) {
      response.data.forEach(normalizeMascotaFoto)
    }
    
    return response.data
  },

  async getMascotasByDueno(params = {}) {
    const response = await api.get('/mascotas/mis-mascotas', { params })
    const raw = response.data

    // Aceptar: { data: [...] }, { success: true, data: [...] }, { data: { data: [...] } }, array directo, o un solo objeto
    let mascotas = []
    if (Array.isArray(raw)) {
      mascotas = raw
    } else if (raw?.data !== undefined) {
      const d = raw.data
      mascotas = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : (d && typeof d === 'object' && (d.id_mascota != null || d.idMascota != null) ? [d] : []))
    } else if (raw && typeof raw === 'object' && (raw.id_mascota != null || raw.idMascota != null)) {
      mascotas = [raw]
    }

    mascotas.forEach(normalizeMascotaFoto)
    return { success: true, data: mascotas }
  },

  async getById(id) {
    const response = await api.get(`/mascotas/${id}`)
    
    // Normalizar foto de la mascota
    if (response.data?.success && response.data?.data) {
      normalizeMascotaFoto(response.data.data)
    } else if (response.data?.data) {
      normalizeMascotaFoto(response.data.data)
    }
    
    return response.data
  },

  async create(data) {
    const response = await api.post('/mascotas', data)
    
    // Normalizar foto de la mascota creada
    if (response.data?.success && response.data?.data) {
      normalizeMascotaFoto(response.data.data)
    } else if (response.data?.data) {
      normalizeMascotaFoto(response.data.data)
    }
    
    return response.data
  },

  async update(id, data) {
    // Laravel/PHP no siempre parsea archivos en multipart/form-data con actualizaciones directas.
    // Para uploads, usamos method override sobre POST.
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData
    const response = isFormData
      ? (() => {
          if (!data.has('_method')) data.append('_method', 'PUT')
          return api.post(`/mascotas/${id}`, data)
        })()
      : api.put(`/mascotas/${id}`, data)
    
    // Normalizar foto de la mascota actualizada
    if (response.data?.success && response.data?.data) {
      normalizeMascotaFoto(response.data.data)
    } else if (response.data?.data) {
      normalizeMascotaFoto(response.data.data)
    }
    
    return response.data
  },

  async deleteAvatar(id) {
    const response = await api.delete(`/mascotas/${id}/avatar`)
    return response.data
  },

  async deactivate(id) {
    const response = await api.patch(`/mascotas/${id}/desactivar`)
    return response.data
  },

  async activate(id) {
    const response = await api.patch(`/mascotas/${id}/activar`)
    return response.data
  },

  async markAsFallecida(id, data) {
    const response = await api.patch(`/mascotas/${id}/marcar-fallecida`, data)
    return response.data
  },

  // Eliminación (soft delete)
  async delete(id) {
    const response = await api.delete(`/mascotas/${id}`)
    return response.data
  },

  // Condiciones de salud
  async getCondiciones(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/condiciones`, { params })
    return response.data
  },

  // Registros de peso
  async getRegistrosPeso(idMascota) {
    const response = await api.get(`/mascotas/${idMascota}/registros-peso`)
    return response.data
  },
}

